import React, { useState } from 'react';
import { Section } from './ui/Section';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const bonusData = [{
  id: 1,
  icon: '🎁',
  number: 'BONO 01',
  title: '100 Ejercicios Resueltos',
  price: '$12.000',
  desc: 'Biblioteca visual con 100 drills completamente resueltos, organizados por objetivo (técnico, táctico, físico) y nivel de dificultad. Cada ejercicio incluye descripción, variantes y consigna lista para usar en la cancha. Nunca más repetir los mismos ejercicios de siempre.'
}, {
  id: 2,
  icon: '🎁',
  number: 'BONO 02',
  title: 'Planillas de Temporada Resueltas',
  price: '$9.000',
  desc: 'Pack completo de planillas editables: asistencia semanal, rendimiento individual, evolución física y técnica del plantel, y control de objetivos por mes. Organizá toda tu temporada en una sola tarde y mostrá resultados concretos a tu club o a tus jugadores.'
}, {
  id: 3,
  icon: '🎁',
  number: 'BONO 03',
  title: 'Diagramas Tácticos Resueltos',
  price: '$8.000',
  desc: '40 páginas de pizarrones tácticos listos para imprimir o proyectar en tu entrenamiento. Corners ofensivos y defensivos, tiros libres, transiciones y sistemas de juego diagramados con claridad profesional. Explicá la táctica en segundos, sin dibujar nada desde cero.'
}, {
  id: 4,
  icon: '🎁',
  number: 'BONO 04',
  title: 'Nutrición del Futbolista Resuelto',
  price: '$10.000',
  desc: 'Guía básica de alimentación deportiva pensada para instructores: qué decirle a tus jugadores antes, durante y después del partido o entrenamiento. Incluye pautas por franja etaria, hidratación y los errores nutricionales más comunes en el fútbol amateur. Sin tecnicismos, directo al punto.'
}, {
  id: 5,
  icon: '🎁',
  number: 'BONO 05',
  title: 'Evaluación y Seguimiento Resuelto',
  price: '$9.000',
  desc: 'Sistema completo para evaluar técnica, condición física y comprensión táctica de cada jugador. Incluye fichas individuales de seguimiento, test de entrada y salida de temporada, y tabla de progresión por jugador. Mostrá resultados reales y justificá tu trabajo como profesional.'
}, {
  id: 6,
  icon: '🎁',
  number: 'BONO 06',
  title: 'El Instructor Profesional Resuelto',
  price: '$8.000',
  desc: 'Cómo cobrar lo que merecés, conseguir trabajo en clubes y escuelas de fútbol, armar tu marca personal como instructor y posicionarte en el mercado. Incluye guía de presentación profesional, modelo de currículum deportivo y estrategia básica de redes sociales para instructores de fútbol.'
}];
export function BonusSlider() {
  const [expandedId, setExpandedId] = useState<number | null>(null);
  const toggleExpand = (id: number) => {
    setExpandedId(expandedId === id ? null : id);
  };
  return <Section className="bg-dark text-white" dark data-id="element-15">
      <div className="text-center mb-6 md:mb-12" data-id="element-16">
        <h2 className="text-3xl md:text-5xl font-black text-gold mb-2 md:mb-4" data-id="element-17">
          Más los 6 Bonos Estratégicos
        </h2>
        <p className="text-base md:text-xl text-gray-300 font-medium" data-id="element-18">
          Incluidos en todas las ofertas — sin costo extra
        </p>
        <p className="text-xs text-gold/80 font-bold mt-2" data-id="element-19">
          Tocá cada bono para ver el detalle
        </p>
      </div>

      {/* Vertical stacked rows */}
      <div className="space-y-3 md:space-y-4" data-id="element-20">
        {bonusData.map(bono => {
        const isExpanded = expandedId === bono.id;
        return <motion.div key={bono.id} layout onClick={() => toggleExpand(bono.id)} className={`cursor-pointer bg-white/5 rounded-xl border transition-all duration-300 relative overflow-hidden ${isExpanded ? 'bg-white/10 border-gold/50' : 'border-white/10 hover:bg-white/10'}`} data-id="element-21">
              {/* Subtle number background */}
              <div className="absolute -right-4 -top-6 text-9xl font-black text-white/5 pointer-events-none select-none z-0" data-id="element-22">
                0{bono.id}
              </div>

              <div className="p-4 md:p-6 relative z-10" data-id="element-23">
                <div className="flex items-center justify-between" data-id="element-24">
                  <div className="flex items-center space-x-3 min-w-0 flex-1" data-id="element-25">
                    <div className="flex items-center justify-center w-10 h-10 md:w-12 md:h-12 bg-white/5 rounded-full border border-white/10 flex-shrink-0" data-id="element-26">
                      <span className="text-xl md:text-2xl" data-id="element-27">{bono.icon}</span>
                    </div>
                    <div className="min-w-0" data-id="element-28">
                      <span className="text-[10px] md:text-sm font-bold text-gold tracking-widest block" data-id="element-29">
                        {bono.number}
                      </span>
                      <h3 className="text-sm md:text-xl font-black text-white leading-tight truncate" data-id="element-30">
                        {bono.title}
                      </h3>
                    </div>
                  </div>
                  <div className="flex items-center space-x-2 flex-shrink-0 ml-2" data-id="element-31">
                    <div className="flex flex-col items-end" data-id="element-32">
                      <span className="text-gray-300 line-through text-[10px] md:text-sm font-bold" data-id="element-33">
                        {bono.price}
                      </span>
                      <span className="bg-primary text-white px-1.5 py-0.5 rounded text-[10px] md:text-xs font-black uppercase" data-id="element-34">
                        GRATIS
                      </span>
                    </div>
                    <motion.div animate={{
                  rotate: isExpanded ? 180 : 0
                }} transition={{
                  duration: 0.3
                }} data-id="element-35">
                      <ChevronDown className="w-5 h-5 text-gray-400" data-id="element-36" />
                    </motion.div>
                  </div>
                </div>

                <AnimatePresence data-id="element-37">
                  {isExpanded && <motion.div initial={{
                opacity: 0,
                height: 0
              }} animate={{
                opacity: 1,
                height: 'auto'
              }} exit={{
                opacity: 0,
                height: 0
              }} transition={{
                duration: 0.3
              }} className="overflow-hidden" data-id="element-38">
                      <div className="pt-3 mt-3 border-t border-white/10" data-id="element-39">
                        <p className="text-gray-200 text-xs md:text-sm leading-relaxed font-medium" data-id="element-40">
                          {bono.desc}
                        </p>
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>
            </motion.div>;
      })}
      </div>

      <div className="mt-8 md:mt-12 text-center relative z-10" data-id="element-41">
        <div className="inline-block border-2 border-gold/30 rounded-xl p-4 md:p-6 bg-white/5 backdrop-blur-sm shadow-xl" data-id="element-42">
          <p className="text-gray-300 font-bold mb-1 text-xs md:text-base" data-id="element-43">
            Valor total de los 6 bonos
          </p>
          <p className="text-2xl md:text-3xl font-black text-white line-through decoration-red-500 decoration-4 mb-1" data-id="element-44">
            $56.000
          </p>
          <p className="text-xl md:text-2xl font-black text-gold" data-id="element-45">
            🎁 GRATIS — Incluidos siempre
          </p>
        </div>
      </div>
    </Section>;
}